export default "__VITE_ASSET__5bdcd678__"